const namespace = 'bravissimo/jobs';

export const RECEIVE_DEPARTMENTS = `${namespace}/RECEIVE_DEPARTMENTS`;
export const RECEIVE_VACANCY = `${namespace}/RECEIVE_VACANCY`;
export const RECEIVE_ROLES = `${namespace}/RECEIVE_ROLES`;
export const RECEIVE_ROLE = `${namespace}/RECEIVE_ROLE`;
